/* Ivory Paw Co – premium interactions */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.ipc [data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function movePill(tabs) {
    var pill = tabs.querySelector('.ipc-tabs__pill');
    var sel = tabs.querySelector('[aria-selected="true"]');
    if (!pill || !sel) return;
    pill.style.width = sel.offsetWidth + 'px';
    pill.style.transform = 'translateX(' + sel.offsetLeft + 'px)';
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-ipc-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var tabs = wrap.querySelector('.ipc-tabs');
      var btns = wrap.querySelectorAll('.ipc-tab');
      btns.forEach(function (b, idx) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); x.tabIndex = x === b ? 0 : -1; });
          wrap.querySelectorAll('.ipc-panel').forEach(function (p) {
            var on = p.id === b.getAttribute('aria-controls');
            p.hidden = !on;
            if (on) { p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering'); }
          });
          movePill(tabs);
        });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = btns[(idx + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length];
          n.focus(); n.click();
        });
      });
      movePill(tabs);
      window.addEventListener('resize', function () { movePill(tabs); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { movePill(tabs); });
    });
  }

  function quickAdd(e) {
    var btn = e.target.closest('[data-ipc-add]');
    if (!btn) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', btn.dataset.ipcAdd);
    fd.append('quantity', '1');
    if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
    var label = btn.querySelector('span'); var orig = label ? label.textContent : '';
    btn.classList.add('is-loading');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res.status) { if (label) label.textContent = res.description || 'Unavailable'; return; }
        btn.classList.add('is-added'); if (label) label.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = orig; }, 2200);
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  function initSpotlight(root) {
    (root || document).querySelectorAll('[data-ipc-spot]').forEach(function (s) {
      if (s.dataset.ready) return; s.dataset.ready = '1';
      var chips = s.querySelectorAll('.ipc-chip'); var rows = s.querySelectorAll('.ipc-spot__specs li');
      function act(i) { chips.forEach(function (c, j) { c.classList.toggle('is-active', j === i); }); rows.forEach(function (r, j) { r.classList.toggle('is-active', j === i); }); }
      chips.forEach(function (c, i) { c.addEventListener('mouseenter', function () { act(i); }); c.addEventListener('focus', function () { act(i); }); });
      rows.forEach(function (r, i) { r.addEventListener('mouseenter', function () { act(i); }); });
      s.addEventListener('mouseleave', function () { act(-1); });
      var stage = s.querySelector('.ipc-spot__stage'); var img = stage && stage.querySelector('img');
      if (stage && img && !reduce && window.matchMedia('(hover:hover)').matches) {
        stage.addEventListener('mousemove', function (e) {
          var r = stage.getBoundingClientRect(); var x = (e.clientX - r.left) / r.width - .5; var y = (e.clientY - r.top) / r.height - .5;
          img.style.transform = 'translate(' + (x * 14) + 'px,' + (y * 14) + 'px) rotate(' + (x * 2) + 'deg)';
        });
        stage.addEventListener('mouseleave', function () { img.style.transform = ''; });
      }
    });
  }

  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('.ipc-parallax');
    if (!items.length) return;
    var ticking = false;
    function run() {
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect(); var vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh; el.style.setProperty('--py', (p * -60).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  function init(root) { initReveal(root); initTabs(root); initSpotlight(root); }
  document.addEventListener('click', quickAdd);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initParallax(); }); else { init(); initParallax(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
